"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClusterSize = exports.calculateClusterAverage = void 0;
const calculateClusterAverage = (markers) => {
    const numericValues = markers
        .map((marker) => marker.value)
        .filter((value) => typeof value === "number");
    if (numericValues.length === 0) {
        return 0;
    }
    const sum = numericValues.reduce((acc, value) => acc + value, 0);
    return sum / numericValues.length;
};
exports.calculateClusterAverage = calculateClusterAverage;
const getClusterSize = (markers) => {
    return markers.length;
};
exports.getClusterSize = getClusterSize;
